import React from 'react';
import { CheckCircle, Brain, Heart, Home } from 'lucide-react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-20 bg-slate-900 text-white overflow-hidden" data-id="element-197">
      <div className="container mx-auto px-4" data-id="element-198">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-199">
          <div className="lg:w-1/2" data-id="element-200">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-201">
              <span className="text-brand-primary font-bold tracking-wider uppercase mb-2 block" data-id="element-202">
                La Solución
              </span>
              <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-203">
                El Método{' '}
                <span className="text-brand-primary" data-id="element-204">RECONQUISTA™</span>
              </h2>
              <p className="text-lg text-slate-300 mb-8 leading-relaxed" data-id="element-205">
                Un sistema paso a paso (R-E-C-O-N) que reestructura el entorno,
                fortalece el vínculo y trabaja con la neurobiología de tu hijo,
                no en su contra.
              </p>

              <div className="space-y-6" data-id="element-206">
                <div className="flex items-start" data-id="element-207">
                  <div className="flex-shrink-0 w-12 h-12 bg-slate-800 rounded-lg flex items-center justify-center mr-4 border border-slate-700" data-id="element-208">
                    <Home className="w-6 h-6 text-brand-primary" data-id="element-209" />
                  </div>
                  <div data-id="element-210">
                    <h3 className="text-xl font-bold text-white mb-2" data-id="element-211">
                      Reestructura el Entorno
                    </h3>
                    <p className="text-slate-400" data-id="element-212">
                      Las rutinas anclan y las zonas libres eliminan la
                      tentación constante, reduciendo la fatiga de decisión.
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-213">
                  <div className="flex-shrink-0 w-12 h-12 bg-slate-800 rounded-lg flex items-center justify-center mr-4 border border-slate-700" data-id="element-214">
                    <Heart className="w-6 h-6 text-brand-primary" data-id="element-215" />
                  </div>
                  <div data-id="element-216">
                    <h3 className="text-xl font-bold text-white mb-2" data-id="element-217">
                      Conexión Pre-Límite
                    </h3>
                    <p className="text-slate-400" data-id="element-218">
                      Reduce un 60% los conflictos al conectar emocionalmente
                      antes de corregir o retirar el dispositivo.
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-219">
                  <div className="flex-shrink-0 w-12 h-12 bg-slate-800 rounded-lg flex items-center justify-center mr-4 border border-slate-700" data-id="element-220">
                    <Brain className="w-6 h-6 text-brand-primary" data-id="element-221" />
                  </div>
                  <div data-id="element-222">
                    <h3 className="text-xl font-bold text-white mb-2" data-id="element-223">
                      Alternativas Dopaminérgicas
                    </h3>
                    <p className="text-slate-400" data-id="element-224">
                      Sustituimos la pantalla con juegos y movimiento que
                      generan dopamina saludable, evitando el síndrome de
                      abstinencia.
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          <div className="lg:w-1/2 relative" data-id="element-225">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="relative z-10 bg-slate-800 p-8 rounded-2xl border border-slate-700 shadow-2xl" data-id="element-226">
              <h3 className="text-2xl font-serif font-bold text-center mb-8 border-b border-slate-700 pb-4" data-id="element-227">
                Resultados en 72 Horas
              </h3>
              <ul className="space-y-4" data-id="element-228">
                <li className="flex items-center bg-slate-900/50 p-4 rounded-lg" data-id="element-229">
                  <CheckCircle className="w-6 h-6 text-brand-success mr-4 flex-shrink-0" data-id="element-230" />
                  <span className="text-slate-200" data-id="element-231">
                    Reducción de berrinches en un 50%
                  </span>
                </li>
                <li className="flex items-center bg-slate-900/50 p-4 rounded-lg" data-id="element-232">
                  <CheckCircle className="w-6 h-6 text-brand-success mr-4 flex-shrink-0" data-id="element-233" />
                  <span className="text-slate-200" data-id="element-234">
                    Mejora significativa en la calidad del sueño
                  </span>
                </li>
                <li className="flex items-center bg-slate-900/50 p-4 rounded-lg" data-id="element-235">
                  <CheckCircle className="w-6 h-6 text-brand-success mr-4 flex-shrink-0" data-id="element-236" />
                  <span className="text-slate-200" data-id="element-237">
                    Recuperación del juego libre espontáneo
                  </span>
                </li>
                <li className="flex items-center bg-slate-900/50 p-4 rounded-lg" data-id="element-238">
                  <CheckCircle className="w-6 h-6 text-brand-success mr-4 flex-shrink-0" data-id="element-239" />
                  <span className="text-slate-200" data-id="element-240">
                    Disminución de la ansiedad y agresividad
                  </span>
                </li>
              </ul>
            </motion.div>

            {/* Decorative elements */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-brand-primary/10 blur-3xl rounded-full -z-10" data-id="element-241" />
          </div>
        </div>
      </div>
    </section>;
}